import { ColourShades } from './colour-shades';

interface SectorColours {
  transport: ColourShades;
  industry: ColourShades;
  agriculture: ColourShades;
  energy: ColourShades;
  other: ColourShades;
}
const sectors: SectorColours = {
  transport: {
    darkest: '#2D5522',
    dark: '#468635',
    main: '#60B748',
    light: '#A0D491',
    lightest: '#CFE9C8',
  },
  industry: {
    darkest: '#18465F',
    dark: '#256D96',
    main: '#3395CC',
    light: '#85BFE0',
    lightest: '#C2DFF0',
  },
  agriculture: {
    darkest: '#7A2F0D',
    dark: '#A84112',
    main: '#E55819',
    light: '#EFA07B',
    lightest: '#F7CDBA',
  },
  energy: {
    darkest: '#9C6800',
    dark: '#C68400',
    main: '#FFAA00',
    light: '#FFCC66',
    lightest: '#FFE6B3',
  },
  other: {
    darkest: '#711C29',
    dark: '#9F2839',
    main: '#CC3349',
    light: '#E69EA9',
    lightest: '#F0C2C8',
  },
};

const unaddressedBaseColour: string = 'black';
const unaddressed: ColourShades = {
  darkest: unaddressedBaseColour,
  dark: '#546478',
  main: '#778493',
  light: '#a4b2c4',
  lightest: unaddressedBaseColour,
};

const abatement: ColourShades = {
  darkest: '#0F243B',
  dark: '#0F243B',
  main: '#0F243B',
  light: '#0F243B',
  lightest: '#0F243B',
};
export const Colours = {
  /**
   * The colour used for abatement, when it isn't coloured by the node colour.
   */
  abatement,
  abatementStrokeColour: '#CDD1D6',
  emissionColour: '#CDD1D6',
  emissionColourDark: '#CDD1D6',
  notAchievableNow: '#73808C',
  notAchievableNowDark: '#73808C',
  gridLineDefaultColour: '#73808C',
  gridHighlightLineDefaultColour: '#B9C0C6',
  gridLabelDefaultColour: '#FFFFFF',
  sectors,
  unaddressed,
  unknownColourDark: '#408578',
  unknownColour: '#5CB1A1',
  unknownColourLight: '#8FC6BC',
};
